import React, { useState } from 'react'

import { Flex, P } from 'ui/acro'
import FooterLink from './FooterLink'
import styled from 'styled-components'
import css from '@styled-system/css'
import { AppleStoreBadge } from 'images'
import { AlomovesIcon } from 'components_v2/Icons'
import { ALO_YOGA_HOME_URL } from 'components_v1/SchemaSectionRenderer/common/components/constants'
import { useUserContext } from 'context'
import ReferralShareModal from 'components_v2/Referral/ReferralShareModal'
import CommonLink from 'components_v2/CommonLink'

const DownloadText = styled.div`
  ${css({
    fontFamily: 'Proxima-nova',
    width: ['70%', '70%', '23%', '23%'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: ['center', 'center', 'flex-start', 'flex-start']
  })}
`
const FooterLinks = () => {
  const context = useUserContext()
  const user = context?.user
  const [showReferral, setShowReferral] = useState(false)

  return (
    <>
      <Flex
        justifyContent='center'
        flexWrap={['wrap-reverse', 'wrap-reverse', 'wrap', 'wrap', 'wrap']}
        alignItems='baseline'
        px='20px'
      >
        <DownloadText>
          <AlomovesIcon
            width={['100px', '130px', '160px']}
            height={['40px', '40px', '70px']}
          />
          <P
            mb='10px'
            fontSize={['12px', '13px', '13px', '15px']}
            textAlign={['center', 'center', 'left']}
          >
            Download the <strong>ALO Wellness Club app</strong> to take classes
            offline and practice anytime, anywhere.
          </P>
          <a
            target='_blank'
            href='https://apps.apple.com/us/app/alo-moves/id601617403'
            rel='noreferrer'
          >
            <AppleStoreBadge width='130px' />
          </a>
        </DownloadText>
        <Flex flexWrap='wrap' justifyContent='center'>
          <FooterLink as={CommonLink} to='/support' id='footer_faq'>
            FAQ
          </FooterLink>
          <FooterLink href='/contact-us' id='footer_contact' external>
            Contact Us
          </FooterLink>
          <FooterLink
            href='https://blog.alomoves.com'
            id='footer_blog'
            external
          >
            Blog
          </FooterLink>
          {user && user.id && (
            <FooterLink
              as='div'
              style={{ cursor: 'pointer' }}
              onClick={() => setShowReferral(true)}
            >
              Refer a Friend
            </FooterLink>
          )}
          <FooterLink
            href='https://boards.greenhouse.io/aloyoga'
            id='footer_careers'
            external
          >
            Careers
          </FooterLink>
          <FooterLink href={ALO_YOGA_HOME_URL} id='footer_alo' external>
            ALO Yoga
          </FooterLink>
        </Flex>
      </Flex>
      {user && user.id && (
        <ReferralShareModal
          show={showReferral}
          onHide={() => setShowReferral(false)}
          userId={user.id}
          entryPoint='footer'
        />
      )}
    </>
  )
}

export default FooterLinks
